<a class="dropdown-item" href (click)="onOpenPaymentModal(); (false)">
  <i class="mr-1 fe fe-dollar-sign fe-fw"></i>
  {{ 'Add payment' | translate }}
</a>
<a
  class="dropdown-item"
  href
  *ngIf="
    !incoming &&
    document.type === 'invoice' &&
    document.clientId &&
    isPast &&
    document.totalDue > 0
  "
  (click)="onOpenReminderModal(); (false)"
>
  <i class="mr-1 fe fe-send fe-fw"></i>
  {{ 'active-documents.send-reminder.menu-item' | translate }}
</a>
<div class="dropdown-divider"></div>
<a
  class="dropdown-item"
  href=""
  [routerLink]="[
    '../../documents',
    !document.incoming ? 'o' : 'i',
    'view',
    document.id
  ]"
>
  <i class="mr-1 fe fe-eye fe-fw"></i>
  {{ 'Open' | translate }}
</a>
<a
  class="dropdown-item"
  href=""
  [routerLink]="[
    '../../documents',
    !document.incoming ? 'o' : 'i',
    'edit',
    document.id
  ]"
  *ngIf="!document._furs || !document._furs.zoi"
>
  <i class="mr-1 fe fe-edit-2 fe-fw"></i>
  {{ 'Edit' | translate }}
</a>
<div class="dropdown-divider" *ngIf="!document.incoming"></div>
<a
  class="dropdown-item"
  href=""
  (click)="!!onOpenEmailModal()"
  *ngIf="!document.incoming"
>
  <i class="mr-1 fe fe-mail fe-fw"></i>
  {{ 'Send' | translate }}
</a>
<a
  class="dropdown-item"
  href=""
  target="_blank"
  (click)="!!onOpenPdf()"
  *ngIf="!document.incoming"
>
  <i class="mr-1 fe fe-file fe-fw"></i>
  {{ 'PDF' | translate }}
</a>
<a
  class="dropdown-item"
  href=""
  (click)="!!onDownloadPdf()"
  *ngIf="!document.incoming"
>
  <i class="mr-1 fe fe-download fe-fw"></i>
  {{ 'Download' | translate }}
</a>
<div class="dropdown-divider"></div>
<a
  class="dropdown-item text-danger"
  href=""
  *ngIf="
    !document.canceled &&
    ((document.type === 'credit-note' && !document._furs) ||
      document.type !== 'credit-note')
  "
  (click)="!!onCancel()"
>
  <i class="mr-1 fe fe-x-circle fe-fw"></i>
  {{ 'Void' | translate }}
</a>
<a
  class="dropdown-item text-danger"
  *ngIf="document.incoming"
  href=""
  (click)="!!onDelete()"
>
  <i class="mr-1 fe fe-trash fe-fw"></i>
  {{ 'Delete' | translate }}
</a>
